import React, { Component } from 'react';
import Carousel from 'react-material-ui-carousel'
import { Paper } from '@material-ui/core'




const CarouselItems = ({items}) => {
    
    return (
        <Carousel indicators={false} timeout={750} animation={"slide"}> 
            
            {
                items.map((item, i) => <Item key={i} item={item} />)
            }
        </Carousel>
    )
}

export default CarouselItems

function Item(props)
{ 
    console.log(props)
    return (
        <Paper>
            <img src={props.item.img} alt="House" style={{ width: '100%',height:'200px' }} />
        </Paper>
    )
}